import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ServerErrorSnackbarComponent } from '../../shared/snack-bar/custom-snack-bar-messages/server-error/server-error-snackbar.component';
import { Clipboard } from '@angular/cdk/clipboard';
import { CustomServerError } from '../../interfaces/custom-server-error.interface';

@Injectable({
    providedIn: 'root',
})
export class MessageUtils {
    constructor(
        private matSnackBar: MatSnackBar,
        private clipboard: Clipboard
    ) {
        this.matSnackBar = matSnackBar;
    }

    showMessage(message: string, actionButton?: string, actionCallback?: (...args: any[]) => any, autoClose: boolean = true): void {
        const config: MatSnackBarConfig = { verticalPosition: 'bottom' };
        if (autoClose) {
            config['duration'] = 4000;
        }

        const snackBarRef = this.matSnackBar.open(message, actionButton, config);
        if (actionCallback) {
            snackBarRef.onAction().subscribe(actionCallback);
        }
    }

    showErrorMessage(message: string, error: any, autoClose: boolean = true): void {
        // TODO: añadir a las traducciones
        const actionButton = 'COPY ERROR';
        const actionCallback = (): void => {
            const userFriendlyError = this.createUserFriendlyError(error);
            this.clipboard.copy(userFriendlyError);
            // TODO: añadir a las traducciones
            this.showMessage('Copied to clipboard');
        };
        const config: MatSnackBarConfig = { verticalPosition: 'bottom', panelClass: ['error-snackbar'] };
        if (autoClose) {
            config['duration'] = 10000;
        }

        const snackBarRef = this.matSnackBar.open(message, actionButton, config);
        if (actionCallback) {
            snackBarRef.onAction().subscribe(actionCallback);
        }
    }

    showServerError(serverError: CustomServerError, genericErrorMessage: string): void {
        if (!serverError?.detail) {
            serverError.detail = genericErrorMessage;
        }

        const config: MatSnackBarConfig = { data: serverError, verticalPosition: 'bottom', duration: 10000 };
        this.matSnackBar.openFromComponent(ServerErrorSnackbarComponent, config);
    }

    private createUserFriendlyError(error: Error): string {
        const timestamp = new Date().toISOString();
        const userAgent = navigator.userAgent;

        let errorReport = `=== ERROR REPORT ===\n`;
        errorReport += `Time: ${timestamp}\n`;
        errorReport += `Browser: ${userAgent}\n`;
        errorReport += `URL: ${window.location.href}\n\n`;

        errorReport += `Error: ${error.name}: ${error.message}\n\n`;

        errorReport += `Stack Trace (for developers):\n`;
        errorReport += `Please open Browser Dev Tools (F12) -> Console to see the detailed stack trace with source file references.\n\n`;

        errorReport += `Raw Stack Trace:\n${error.stack || 'No stack trace available'}`;

        return errorReport;
    }
}
